module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/point_yellow-f887f4adc168e226eeb05579f582e9ff.png";